/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as HowToUseRouteImport } from './routes/how-to-use'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReaderPdfRouteImport } from './routes/reader.pdf'
import { Route as ReaderEpubRouteImport } from './routes/reader.epub'
import { Route as AuthenticatedLayoutBasicRouteImport } from './routes/_authenticated/_layout-basic'
import { Route as AuthenticatedLayoutAdvancedRouteImport } from './routes/_authenticated/_layout-advanced'
import { Route as AuthenticatedCreatorRouteImport } from './routes/_authenticated/_creator'
import { Route as AuthVerifyLoginRouteImport } from './routes/_auth/verify-login'
import { Route as AuthOtpLoginRouteImport } from './routes/_auth/otp-login'
import { Route as AuthMagicLinkRouteImport } from './routes/_auth/magic-link'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthCreatorRegisterRouteImport } from './routes/_auth/creator-register'
import { Route as AuthCreatorLoginRouteImport } from './routes/_auth/creator-login'
import { Route as AuthCompleteProfileRouteImport } from './routes/_auth/complete-profile'
import { Route as AuthCompleteCreatorRouteImport } from './routes/_auth/complete-creator'
import { Route as AuthenticatedCoursesCourseIdRouteImport } from './routes/_authenticated/courses.$courseId'
import { Route as AuthenticatedLayoutBasicProfileRouteImport } from './routes/_authenticated/_layout-basic/profile'
import { Route as AuthenticatedLayoutBasic2faRouteImport } from './routes/_authenticated/_layout-basic/2fa'
import { Route as AuthenticatedLayoutAdvancedSupportRouteImport } from './routes/_authenticated/_layout-advanced/support'
import { Route as AuthenticatedLayoutAdvancedExpiredCoursesRouteImport } from './routes/_authenticated/_layout-advanced/expired-courses'
import { Route as AuthenticatedLayoutAdvancedDashboardRouteImport } from './routes/_authenticated/_layout-advanced/dashboard'
import { Route as AuthenticatedLayoutAdvancedContactRouteImport } from './routes/_authenticated/_layout-advanced/contact'
import { Route as AuthenticatedCreatorPaulRouteImport } from './routes/_authenticated/_creator/paul'
import { Route as AuthenticatedCreatorCreatorSupportRouteImport } from './routes/_authenticated/_creator/creator-support'
import { Route as AuthenticatedCreatorCreatorFaqRouteImport } from './routes/_authenticated/_creator/creator-faq'
import { Route as AuthenticatedCreatorMaterialsRouteRouteImport } from './routes/_authenticated/_creator/materials/route'
import { Route as AuthenticatedLayoutBasicPasskeyIndexRouteImport } from './routes/_authenticated/_layout-basic/passkey/index'
import { Route as AuthenticatedCreatorRequestsIndexRouteImport } from './routes/_authenticated/_creator/requests/index'
import { Route as AuthenticatedCreatorOutOfPrintIndexRouteImport } from './routes/_authenticated/_creator/out-of-print/index'
import { Route as AuthenticatedLayoutBasicPasskeyPasskeyRouteImport } from './routes/_authenticated/_layout-basic/passkey/$passkey'
import { Route as AuthenticatedCreatorRequestsCreateRouteImport } from './routes/_authenticated/_creator/requests/create'
import { Route as AuthenticatedCreatorOutOfPrintPublicationIdRouteImport } from './routes/_authenticated/_creator/out-of-print/$publicationId'
import { Route as AuthenticatedCreatorRequestsRequestIdIndexRouteImport } from './routes/_authenticated/_creator/requests/$requestId/index'
import { Route as AuthenticatedLayoutAdvancedCoursesCourseIdShortViewRouteImport } from './routes/_authenticated/_layout-advanced/courses/$courseId/short-view'
import { Route as AuthenticatedLayoutAdvancedCoursesCourseIdDetailsRouteImport } from './routes/_authenticated/_layout-advanced/courses/$courseId/details'
import { Route as AuthenticatedCreatorRequestsRequestIdEditRouteImport } from './routes/_authenticated/_creator/requests/$requestId/edit'
import { Route as AuthenticatedCreatorMaterialsCreatePdfRouteImport } from './routes/_authenticated/_creator/materials/create/pdf'
import { Route as AuthenticatedCreatorMaterialsCreateMultimediaRouteImport } from './routes/_authenticated/_creator/materials/create/multimedia'
import { Route as AuthenticatedCreatorMaterialsIdEditRouteImport } from './routes/_authenticated/_creator/materials/$id/edit'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const HowToUseRoute = HowToUseRouteImport.update({
  id: '/how-to-use',
  path: '/how-to-use',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReaderPdfRoute = ReaderPdfRouteImport.update({
  id: '/reader/pdf',
  path: '/reader/pdf',
  getParentRoute: () => rootRouteImport,
} as any)
const ReaderEpubRoute = ReaderEpubRouteImport.update({
  id: '/reader/epub',
  path: '/reader/epub',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedLayoutBasicRoute =
  AuthenticatedLayoutBasicRouteImport.update({
    id: '/_layout-basic',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLayoutAdvancedRoute =
  AuthenticatedLayoutAdvancedRouteImport.update({
    id: '/_layout-advanced',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCreatorRoute = AuthenticatedCreatorRouteImport.update({
  id: '/_creator',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthVerifyLoginRoute = AuthVerifyLoginRouteImport.update({
  id: '/verify-login',
  path: '/verify-login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOtpLoginRoute = AuthOtpLoginRouteImport.update({
  id: '/otp-login',
  path: '/otp-login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMagicLinkRoute = AuthMagicLinkRouteImport.update({
  id: '/magic-link',
  path: '/magic-link',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCreatorRegisterRoute = AuthCreatorRegisterRouteImport.update({
  id: '/creator-register',
  path: '/creator-register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCreatorLoginRoute = AuthCreatorLoginRouteImport.update({
  id: '/creator-login',
  path: '/creator-login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCompleteProfileRoute = AuthCompleteProfileRouteImport.update({
  id: '/complete-profile',
  path: '/complete-profile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCompleteCreatorRoute = AuthCompleteCreatorRouteImport.update({
  id: '/complete-creator',
  path: '/complete-creator',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedCoursesCourseIdRoute =
  AuthenticatedCoursesCourseIdRouteImport.update({
    id: '/courses/$courseId',
    path: '/courses/$courseId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLayoutBasicProfileRoute =
  AuthenticatedLayoutBasicProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedLayoutBasicRoute,
  } as any)
const AuthenticatedLayoutBasic2faRoute =
  AuthenticatedLayoutBasic2faRouteImport.update({
    id: '/2fa',
    path: '/2fa',
    getParentRoute: () => AuthenticatedLayoutBasicRoute,
  } as any)
const AuthenticatedLayoutAdvancedSupportRoute =
  AuthenticatedLayoutAdvancedSupportRouteImport.update({
    id: '/support',
    path: '/support',
    getParentRoute: () => AuthenticatedLayoutAdvancedRoute,
  } as any)
const AuthenticatedLayoutAdvancedExpiredCoursesRoute =
  AuthenticatedLayoutAdvancedExpiredCoursesRouteImport.update({
    id: '/expired-courses',
    path: '/expired-courses',
    getParentRoute: () => AuthenticatedLayoutAdvancedRoute,
  } as any)
const AuthenticatedLayoutAdvancedDashboardRoute =
  AuthenticatedLayoutAdvancedDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedLayoutAdvancedRoute,
  } as any)
const AuthenticatedLayoutAdvancedContactRoute =
  AuthenticatedLayoutAdvancedContactRouteImport.update({
    id: '/contact',
    path: '/contact',
    getParentRoute: () => AuthenticatedLayoutAdvancedRoute,
  } as any)
const AuthenticatedCreatorPaulRoute =
  AuthenticatedCreatorPaulRouteImport.update({
    id: '/paul',
    path: '/paul',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)
const AuthenticatedCreatorCreatorSupportRoute =
  AuthenticatedCreatorCreatorSupportRouteImport.update({
    id: '/creator-support',
    path: '/creator-support',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)
const AuthenticatedCreatorCreatorFaqRoute =
  AuthenticatedCreatorCreatorFaqRouteImport.update({
    id: '/creator-faq',
    path: '/creator-faq',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)
const AuthenticatedCreatorMaterialsRouteRoute =
  AuthenticatedCreatorMaterialsRouteRouteImport.update({
    id: '/materials',
    path: '/materials',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)
const AuthenticatedLayoutBasicPasskeyIndexRoute =
  AuthenticatedLayoutBasicPasskeyIndexRouteImport.update({
    id: '/passkey/',
    path: '/passkey/',
    getParentRoute: () => AuthenticatedLayoutBasicRoute,
  } as any)
const AuthenticatedCreatorRequestsIndexRoute =
  AuthenticatedCreatorRequestsIndexRouteImport.update({
    id: '/requests/',
    path: '/requests/',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)
const AuthenticatedCreatorOutOfPrintIndexRoute =
  AuthenticatedCreatorOutOfPrintIndexRouteImport.update({
    id: '/out-of-print/',
    path: '/out-of-print/',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)
const AuthenticatedLayoutBasicPasskeyPasskeyRoute =
  AuthenticatedLayoutBasicPasskeyPasskeyRouteImport.update({
    id: '/passkey/$passkey',
    path: '/passkey/$passkey',
    getParentRoute: () => AuthenticatedLayoutBasicRoute,
  } as any)
const AuthenticatedCreatorRequestsCreateRoute =
  AuthenticatedCreatorRequestsCreateRouteImport.update({
    id: '/requests/create',
    path: '/requests/create',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)
const AuthenticatedCreatorOutOfPrintPublicationIdRoute =
  AuthenticatedCreatorOutOfPrintPublicationIdRouteImport.update({
    id: '/out-of-print/$publicationId',
    path: '/out-of-print/$publicationId',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)
const AuthenticatedCreatorRequestsRequestIdIndexRoute =
  AuthenticatedCreatorRequestsRequestIdIndexRouteImport.update({
    id: '/requests/$requestId/',
    path: '/requests/$requestId/',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)
const AuthenticatedLayoutAdvancedCoursesCourseIdShortViewRoute =
  AuthenticatedLayoutAdvancedCoursesCourseIdShortViewRouteImport.update({
    id: '/courses/$courseId/short-view',
    path: '/courses/$courseId/short-view',
    getParentRoute: () => AuthenticatedLayoutAdvancedRoute,
  } as any)
const AuthenticatedLayoutAdvancedCoursesCourseIdDetailsRoute =
  AuthenticatedLayoutAdvancedCoursesCourseIdDetailsRouteImport.update({
    id: '/courses/$courseId/details',
    path: '/courses/$courseId/details',
    getParentRoute: () => AuthenticatedLayoutAdvancedRoute,
  } as any)
const AuthenticatedCreatorRequestsRequestIdEditRoute =
  AuthenticatedCreatorRequestsRequestIdEditRouteImport.update({
    id: '/requests/$requestId/edit',
    path: '/requests/$requestId/edit',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)
const AuthenticatedCreatorMaterialsCreatePdfRoute =
  AuthenticatedCreatorMaterialsCreatePdfRouteImport.update({
    id: '/create/pdf',
    path: '/create/pdf',
    getParentRoute: () => AuthenticatedCreatorMaterialsRouteRoute,
  } as any)
const AuthenticatedCreatorMaterialsCreateMultimediaRoute =
  AuthenticatedCreatorMaterialsCreateMultimediaRouteImport.update({
    id: '/create/multimedia',
    path: '/create/multimedia',
    getParentRoute: () => AuthenticatedCreatorMaterialsRouteRoute,
  } as any)
const AuthenticatedCreatorMaterialsIdEditRoute =
  AuthenticatedCreatorMaterialsIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AuthenticatedCreatorMaterialsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/how-to-use': typeof HowToUseRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/complete-creator': typeof AuthCompleteCreatorRoute
  '/complete-profile': typeof AuthCompleteProfileRoute
  '/creator-login': typeof AuthCreatorLoginRoute
  '/creator-register': typeof AuthCreatorRegisterRoute
  '/login': typeof AuthLoginRoute
  '/magic-link': typeof AuthMagicLinkRoute
  '/otp-login': typeof AuthOtpLoginRoute
  '/verify-login': typeof AuthVerifyLoginRoute
  '/reader/epub': typeof ReaderEpubRoute
  '/reader/pdf': typeof ReaderPdfRoute
  '/materials': typeof AuthenticatedCreatorMaterialsRouteRouteWithChildren
  '/creator-faq': typeof AuthenticatedCreatorCreatorFaqRoute
  '/creator-support': typeof AuthenticatedCreatorCreatorSupportRoute
  '/paul': typeof AuthenticatedCreatorPaulRoute
  '/contact': typeof AuthenticatedLayoutAdvancedContactRoute
  '/dashboard': typeof AuthenticatedLayoutAdvancedDashboardRoute
  '/expired-courses': typeof AuthenticatedLayoutAdvancedExpiredCoursesRoute
  '/support': typeof AuthenticatedLayoutAdvancedSupportRoute
  '/2fa': typeof AuthenticatedLayoutBasic2faRoute
  '/profile': typeof AuthenticatedLayoutBasicProfileRoute
  '/courses/$courseId': typeof AuthenticatedCoursesCourseIdRoute
  '/out-of-print/$publicationId': typeof AuthenticatedCreatorOutOfPrintPublicationIdRoute
  '/requests/create': typeof AuthenticatedCreatorRequestsCreateRoute
  '/passkey/$passkey': typeof AuthenticatedLayoutBasicPasskeyPasskeyRoute
  '/out-of-print/': typeof AuthenticatedCreatorOutOfPrintIndexRoute
  '/requests/': typeof AuthenticatedCreatorRequestsIndexRoute
  '/passkey/': typeof AuthenticatedLayoutBasicPasskeyIndexRoute
  '/materials/$id/edit': typeof AuthenticatedCreatorMaterialsIdEditRoute
  '/materials/create/multimedia': typeof AuthenticatedCreatorMaterialsCreateMultimediaRoute
  '/materials/create/pdf': typeof AuthenticatedCreatorMaterialsCreatePdfRoute
  '/requests/$requestId/edit': typeof AuthenticatedCreatorRequestsRequestIdEditRoute
  '/courses/$courseId/details': typeof AuthenticatedLayoutAdvancedCoursesCourseIdDetailsRoute
  '/courses/$courseId/short-view': typeof AuthenticatedLayoutAdvancedCoursesCourseIdShortViewRoute
  '/requests/$requestId/': typeof AuthenticatedCreatorRequestsRequestIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/how-to-use': typeof HowToUseRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/complete-creator': typeof AuthCompleteCreatorRoute
  '/complete-profile': typeof AuthCompleteProfileRoute
  '/creator-login': typeof AuthCreatorLoginRoute
  '/creator-register': typeof AuthCreatorRegisterRoute
  '/login': typeof AuthLoginRoute
  '/magic-link': typeof AuthMagicLinkRoute
  '/otp-login': typeof AuthOtpLoginRoute
  '/verify-login': typeof AuthVerifyLoginRoute
  '/reader/epub': typeof ReaderEpubRoute
  '/reader/pdf': typeof ReaderPdfRoute
  '/materials': typeof AuthenticatedCreatorMaterialsRouteRouteWithChildren
  '/creator-faq': typeof AuthenticatedCreatorCreatorFaqRoute
  '/creator-support': typeof AuthenticatedCreatorCreatorSupportRoute
  '/paul': typeof AuthenticatedCreatorPaulRoute
  '/contact': typeof AuthenticatedLayoutAdvancedContactRoute
  '/dashboard': typeof AuthenticatedLayoutAdvancedDashboardRoute
  '/expired-courses': typeof AuthenticatedLayoutAdvancedExpiredCoursesRoute
  '/support': typeof AuthenticatedLayoutAdvancedSupportRoute
  '/2fa': typeof AuthenticatedLayoutBasic2faRoute
  '/profile': typeof AuthenticatedLayoutBasicProfileRoute
  '/courses/$courseId': typeof AuthenticatedCoursesCourseIdRoute
  '/out-of-print/$publicationId': typeof AuthenticatedCreatorOutOfPrintPublicationIdRoute
  '/requests/create': typeof AuthenticatedCreatorRequestsCreateRoute
  '/passkey/$passkey': typeof AuthenticatedLayoutBasicPasskeyPasskeyRoute
  '/out-of-print': typeof AuthenticatedCreatorOutOfPrintIndexRoute
  '/requests': typeof AuthenticatedCreatorRequestsIndexRoute
  '/passkey': typeof AuthenticatedLayoutBasicPasskeyIndexRoute
  '/materials/$id/edit': typeof AuthenticatedCreatorMaterialsIdEditRoute
  '/materials/create/multimedia': typeof AuthenticatedCreatorMaterialsCreateMultimediaRoute
  '/materials/create/pdf': typeof AuthenticatedCreatorMaterialsCreatePdfRoute
  '/requests/$requestId/edit': typeof AuthenticatedCreatorRequestsRequestIdEditRoute
  '/courses/$courseId/details': typeof AuthenticatedLayoutAdvancedCoursesCourseIdDetailsRoute
  '/courses/$courseId/short-view': typeof AuthenticatedLayoutAdvancedCoursesCourseIdShortViewRoute
  '/requests/$requestId': typeof AuthenticatedCreatorRequestsRequestIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/how-to-use': typeof HowToUseRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_auth/complete-creator': typeof AuthCompleteCreatorRoute
  '/_auth/complete-profile': typeof AuthCompleteProfileRoute
  '/_auth/creator-login': typeof AuthCreatorLoginRoute
  '/_auth/creator-register': typeof AuthCreatorRegisterRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/magic-link': typeof AuthMagicLinkRoute
  '/_auth/otp-login': typeof AuthOtpLoginRoute
  '/_auth/verify-login': typeof AuthVerifyLoginRoute
  '/_authenticated/_creator': typeof AuthenticatedCreatorRouteWithChildren
  '/_authenticated/_layout-advanced': typeof AuthenticatedLayoutAdvancedRouteWithChildren
  '/_authenticated/_layout-basic': typeof AuthenticatedLayoutBasicRouteWithChildren
  '/reader/epub': typeof ReaderEpubRoute
  '/reader/pdf': typeof ReaderPdfRoute
  '/_authenticated/_creator/materials': typeof AuthenticatedCreatorMaterialsRouteRouteWithChildren
  '/_authenticated/_creator/creator-faq': typeof AuthenticatedCreatorCreatorFaqRoute
  '/_authenticated/_creator/creator-support': typeof AuthenticatedCreatorCreatorSupportRoute
  '/_authenticated/_creator/paul': typeof AuthenticatedCreatorPaulRoute
  '/_authenticated/_layout-advanced/contact': typeof AuthenticatedLayoutAdvancedContactRoute
  '/_authenticated/_layout-advanced/dashboard': typeof AuthenticatedLayoutAdvancedDashboardRoute
  '/_authenticated/_layout-advanced/expired-courses': typeof AuthenticatedLayoutAdvancedExpiredCoursesRoute
  '/_authenticated/_layout-advanced/support': typeof AuthenticatedLayoutAdvancedSupportRoute
  '/_authenticated/_layout-basic/2fa': typeof AuthenticatedLayoutBasic2faRoute
  '/_authenticated/_layout-basic/profile': typeof AuthenticatedLayoutBasicProfileRoute
  '/_authenticated/courses/$courseId': typeof AuthenticatedCoursesCourseIdRoute
  '/_authenticated/_creator/out-of-print/$publicationId': typeof AuthenticatedCreatorOutOfPrintPublicationIdRoute
  '/_authenticated/_creator/requests/create': typeof AuthenticatedCreatorRequestsCreateRoute
  '/_authenticated/_layout-basic/passkey/$passkey': typeof AuthenticatedLayoutBasicPasskeyPasskeyRoute
  '/_authenticated/_creator/out-of-print/': typeof AuthenticatedCreatorOutOfPrintIndexRoute
  '/_authenticated/_creator/requests/': typeof AuthenticatedCreatorRequestsIndexRoute
  '/_authenticated/_layout-basic/passkey/': typeof AuthenticatedLayoutBasicPasskeyIndexRoute
  '/_authenticated/_creator/materials/$id/edit': typeof AuthenticatedCreatorMaterialsIdEditRoute
  '/_authenticated/_creator/materials/create/multimedia': typeof AuthenticatedCreatorMaterialsCreateMultimediaRoute
  '/_authenticated/_creator/materials/create/pdf': typeof AuthenticatedCreatorMaterialsCreatePdfRoute
  '/_authenticated/_creator/requests/$requestId/edit': typeof AuthenticatedCreatorRequestsRequestIdEditRoute
  '/_authenticated/_layout-advanced/courses/$courseId/details': typeof AuthenticatedLayoutAdvancedCoursesCourseIdDetailsRoute
  '/_authenticated/_layout-advanced/courses/$courseId/short-view': typeof AuthenticatedLayoutAdvancedCoursesCourseIdShortViewRoute
  '/_authenticated/_creator/requests/$requestId/': typeof AuthenticatedCreatorRequestsRequestIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/how-to-use'
    | '/privacy'
    | '/terms'
    | '/verify-email'
    | '/complete-creator'
    | '/complete-profile'
    | '/creator-login'
    | '/creator-register'
    | '/login'
    | '/magic-link'
    | '/otp-login'
    | '/verify-login'
    | '/reader/epub'
    | '/reader/pdf'
    | '/materials'
    | '/creator-faq'
    | '/creator-support'
    | '/paul'
    | '/contact'
    | '/dashboard'
    | '/expired-courses'
    | '/support'
    | '/2fa'
    | '/profile'
    | '/courses/$courseId'
    | '/out-of-print/$publicationId'
    | '/requests/create'
    | '/passkey/$passkey'
    | '/out-of-print/'
    | '/requests/'
    | '/passkey/'
    | '/materials/$id/edit'
    | '/materials/create/multimedia'
    | '/materials/create/pdf'
    | '/requests/$requestId/edit'
    | '/courses/$courseId/details'
    | '/courses/$courseId/short-view'
    | '/requests/$requestId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/how-to-use'
    | '/privacy'
    | '/terms'
    | '/verify-email'
    | '/complete-creator'
    | '/complete-profile'
    | '/creator-login'
    | '/creator-register'
    | '/login'
    | '/magic-link'
    | '/otp-login'
    | '/verify-login'
    | '/reader/epub'
    | '/reader/pdf'
    | '/materials'
    | '/creator-faq'
    | '/creator-support'
    | '/paul'
    | '/contact'
    | '/dashboard'
    | '/expired-courses'
    | '/support'
    | '/2fa'
    | '/profile'
    | '/courses/$courseId'
    | '/out-of-print/$publicationId'
    | '/requests/create'
    | '/passkey/$passkey'
    | '/out-of-print'
    | '/requests'
    | '/passkey'
    | '/materials/$id/edit'
    | '/materials/create/multimedia'
    | '/materials/create/pdf'
    | '/requests/$requestId/edit'
    | '/courses/$courseId/details'
    | '/courses/$courseId/short-view'
    | '/requests/$requestId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_authenticated'
    | '/how-to-use'
    | '/privacy'
    | '/terms'
    | '/verify-email'
    | '/_auth/complete-creator'
    | '/_auth/complete-profile'
    | '/_auth/creator-login'
    | '/_auth/creator-register'
    | '/_auth/login'
    | '/_auth/magic-link'
    | '/_auth/otp-login'
    | '/_auth/verify-login'
    | '/_authenticated/_creator'
    | '/_authenticated/_layout-advanced'
    | '/_authenticated/_layout-basic'
    | '/reader/epub'
    | '/reader/pdf'
    | '/_authenticated/_creator/materials'
    | '/_authenticated/_creator/creator-faq'
    | '/_authenticated/_creator/creator-support'
    | '/_authenticated/_creator/paul'
    | '/_authenticated/_layout-advanced/contact'
    | '/_authenticated/_layout-advanced/dashboard'
    | '/_authenticated/_layout-advanced/expired-courses'
    | '/_authenticated/_layout-advanced/support'
    | '/_authenticated/_layout-basic/2fa'
    | '/_authenticated/_layout-basic/profile'
    | '/_authenticated/courses/$courseId'
    | '/_authenticated/_creator/out-of-print/$publicationId'
    | '/_authenticated/_creator/requests/create'
    | '/_authenticated/_layout-basic/passkey/$passkey'
    | '/_authenticated/_creator/out-of-print/'
    | '/_authenticated/_creator/requests/'
    | '/_authenticated/_layout-basic/passkey/'
    | '/_authenticated/_creator/materials/$id/edit'
    | '/_authenticated/_creator/materials/create/multimedia'
    | '/_authenticated/_creator/materials/create/pdf'
    | '/_authenticated/_creator/requests/$requestId/edit'
    | '/_authenticated/_layout-advanced/courses/$courseId/details'
    | '/_authenticated/_layout-advanced/courses/$courseId/short-view'
    | '/_authenticated/_creator/requests/$requestId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  HowToUseRoute: typeof HowToUseRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  ReaderEpubRoute: typeof ReaderEpubRoute
  ReaderPdfRoute: typeof ReaderPdfRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/how-to-use': {
      id: '/how-to-use'
      path: '/how-to-use'
      fullPath: '/how-to-use'
      preLoaderRoute: typeof HowToUseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reader/pdf': {
      id: '/reader/pdf'
      path: '/reader/pdf'
      fullPath: '/reader/pdf'
      preLoaderRoute: typeof ReaderPdfRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reader/epub': {
      id: '/reader/epub'
      path: '/reader/epub'
      fullPath: '/reader/epub'
      preLoaderRoute: typeof ReaderEpubRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_layout-basic': {
      id: '/_authenticated/_layout-basic'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutBasicRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_layout-advanced': {
      id: '/_authenticated/_layout-advanced'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutAdvancedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_creator': {
      id: '/_authenticated/_creator'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedCreatorRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth/verify-login': {
      id: '/_auth/verify-login'
      path: '/verify-login'
      fullPath: '/verify-login'
      preLoaderRoute: typeof AuthVerifyLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/otp-login': {
      id: '/_auth/otp-login'
      path: '/otp-login'
      fullPath: '/otp-login'
      preLoaderRoute: typeof AuthOtpLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/magic-link': {
      id: '/_auth/magic-link'
      path: '/magic-link'
      fullPath: '/magic-link'
      preLoaderRoute: typeof AuthMagicLinkRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/creator-register': {
      id: '/_auth/creator-register'
      path: '/creator-register'
      fullPath: '/creator-register'
      preLoaderRoute: typeof AuthCreatorRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/creator-login': {
      id: '/_auth/creator-login'
      path: '/creator-login'
      fullPath: '/creator-login'
      preLoaderRoute: typeof AuthCreatorLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/complete-profile': {
      id: '/_auth/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof AuthCompleteProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/complete-creator': {
      id: '/_auth/complete-creator'
      path: '/complete-creator'
      fullPath: '/complete-creator'
      preLoaderRoute: typeof AuthCompleteCreatorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/courses/$courseId': {
      id: '/_authenticated/courses/$courseId'
      path: '/courses/$courseId'
      fullPath: '/courses/$courseId'
      preLoaderRoute: typeof AuthenticatedCoursesCourseIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_layout-basic/profile': {
      id: '/_authenticated/_layout-basic/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedLayoutBasicProfileRouteImport
      parentRoute: typeof AuthenticatedLayoutBasicRoute
    }
    '/_authenticated/_layout-basic/2fa': {
      id: '/_authenticated/_layout-basic/2fa'
      path: '/2fa'
      fullPath: '/2fa'
      preLoaderRoute: typeof AuthenticatedLayoutBasic2faRouteImport
      parentRoute: typeof AuthenticatedLayoutBasicRoute
    }
    '/_authenticated/_layout-advanced/support': {
      id: '/_authenticated/_layout-advanced/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedLayoutAdvancedSupportRouteImport
      parentRoute: typeof AuthenticatedLayoutAdvancedRoute
    }
    '/_authenticated/_layout-advanced/expired-courses': {
      id: '/_authenticated/_layout-advanced/expired-courses'
      path: '/expired-courses'
      fullPath: '/expired-courses'
      preLoaderRoute: typeof AuthenticatedLayoutAdvancedExpiredCoursesRouteImport
      parentRoute: typeof AuthenticatedLayoutAdvancedRoute
    }
    '/_authenticated/_layout-advanced/dashboard': {
      id: '/_authenticated/_layout-advanced/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedLayoutAdvancedDashboardRouteImport
      parentRoute: typeof AuthenticatedLayoutAdvancedRoute
    }
    '/_authenticated/_layout-advanced/contact': {
      id: '/_authenticated/_layout-advanced/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof AuthenticatedLayoutAdvancedContactRouteImport
      parentRoute: typeof AuthenticatedLayoutAdvancedRoute
    }
    '/_authenticated/_creator/paul': {
      id: '/_authenticated/_creator/paul'
      path: '/paul'
      fullPath: '/paul'
      preLoaderRoute: typeof AuthenticatedCreatorPaulRouteImport
      parentRoute: typeof AuthenticatedCreatorRoute
    }
    '/_authenticated/_creator/creator-support': {
      id: '/_authenticated/_creator/creator-support'
      path: '/creator-support'
      fullPath: '/creator-support'
      preLoaderRoute: typeof AuthenticatedCreatorCreatorSupportRouteImport
      parentRoute: typeof AuthenticatedCreatorRoute
    }
    '/_authenticated/_creator/creator-faq': {
      id: '/_authenticated/_creator/creator-faq'
      path: '/creator-faq'
      fullPath: '/creator-faq'
      preLoaderRoute: typeof AuthenticatedCreatorCreatorFaqRouteImport
      parentRoute: typeof AuthenticatedCreatorRoute
    }
    '/_authenticated/_creator/materials': {
      id: '/_authenticated/_creator/materials'
      path: '/materials'
      fullPath: '/materials'
      preLoaderRoute: typeof AuthenticatedCreatorMaterialsRouteRouteImport
      parentRoute: typeof AuthenticatedCreatorRoute
    }
    '/_authenticated/_layout-basic/passkey/': {
      id: '/_authenticated/_layout-basic/passkey/'
      path: '/passkey'
      fullPath: '/passkey/'
      preLoaderRoute: typeof AuthenticatedLayoutBasicPasskeyIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutBasicRoute
    }
    '/_authenticated/_creator/requests/': {
      id: '/_authenticated/_creator/requests/'
      path: '/requests'
      fullPath: '/requests/'
      preLoaderRoute: typeof AuthenticatedCreatorRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedCreatorRoute
    }
    '/_authenticated/_creator/out-of-print/': {
      id: '/_authenticated/_creator/out-of-print/'
      path: '/out-of-print'
      fullPath: '/out-of-print/'
      preLoaderRoute: typeof AuthenticatedCreatorOutOfPrintIndexRouteImport
      parentRoute: typeof AuthenticatedCreatorRoute
    }
    '/_authenticated/_layout-basic/passkey/$passkey': {
      id: '/_authenticated/_layout-basic/passkey/$passkey'
      path: '/passkey/$passkey'
      fullPath: '/passkey/$passkey'
      preLoaderRoute: typeof AuthenticatedLayoutBasicPasskeyPasskeyRouteImport
      parentRoute: typeof AuthenticatedLayoutBasicRoute
    }
    '/_authenticated/_creator/requests/create': {
      id: '/_authenticated/_creator/requests/create'
      path: '/requests/create'
      fullPath: '/requests/create'
      preLoaderRoute: typeof AuthenticatedCreatorRequestsCreateRouteImport
      parentRoute: typeof AuthenticatedCreatorRoute
    }
    '/_authenticated/_creator/out-of-print/$publicationId': {
      id: '/_authenticated/_creator/out-of-print/$publicationId'
      path: '/out-of-print/$publicationId'
      fullPath: '/out-of-print/$publicationId'
      preLoaderRoute: typeof AuthenticatedCreatorOutOfPrintPublicationIdRouteImport
      parentRoute: typeof AuthenticatedCreatorRoute
    }
    '/_authenticated/_creator/requests/$requestId/': {
      id: '/_authenticated/_creator/requests/$requestId/'
      path: '/requests/$requestId'
      fullPath: '/requests/$requestId/'
      preLoaderRoute: typeof AuthenticatedCreatorRequestsRequestIdIndexRouteImport
      parentRoute: typeof AuthenticatedCreatorRoute
    }
    '/_authenticated/_layout-advanced/courses/$courseId/short-view': {
      id: '/_authenticated/_layout-advanced/courses/$courseId/short-view'
      path: '/courses/$courseId/short-view'
      fullPath: '/courses/$courseId/short-view'
      preLoaderRoute: typeof AuthenticatedLayoutAdvancedCoursesCourseIdShortViewRouteImport
      parentRoute: typeof AuthenticatedLayoutAdvancedRoute
    }
    '/_authenticated/_layout-advanced/courses/$courseId/details': {
      id: '/_authenticated/_layout-advanced/courses/$courseId/details'
      path: '/courses/$courseId/details'
      fullPath: '/courses/$courseId/details'
      preLoaderRoute: typeof AuthenticatedLayoutAdvancedCoursesCourseIdDetailsRouteImport
      parentRoute: typeof AuthenticatedLayoutAdvancedRoute
    }
    '/_authenticated/_creator/requests/$requestId/edit': {
      id: '/_authenticated/_creator/requests/$requestId/edit'
      path: '/requests/$requestId/edit'
      fullPath: '/requests/$requestId/edit'
      preLoaderRoute: typeof AuthenticatedCreatorRequestsRequestIdEditRouteImport
      parentRoute: typeof AuthenticatedCreatorRoute
    }
    '/_authenticated/_creator/materials/create/pdf': {
      id: '/_authenticated/_creator/materials/create/pdf'
      path: '/create/pdf'
      fullPath: '/materials/create/pdf'
      preLoaderRoute: typeof AuthenticatedCreatorMaterialsCreatePdfRouteImport
      parentRoute: typeof AuthenticatedCreatorMaterialsRouteRoute
    }
    '/_authenticated/_creator/materials/create/multimedia': {
      id: '/_authenticated/_creator/materials/create/multimedia'
      path: '/create/multimedia'
      fullPath: '/materials/create/multimedia'
      preLoaderRoute: typeof AuthenticatedCreatorMaterialsCreateMultimediaRouteImport
      parentRoute: typeof AuthenticatedCreatorMaterialsRouteRoute
    }
    '/_authenticated/_creator/materials/$id/edit': {
      id: '/_authenticated/_creator/materials/$id/edit'
      path: '/$id/edit'
      fullPath: '/materials/$id/edit'
      preLoaderRoute: typeof AuthenticatedCreatorMaterialsIdEditRouteImport
      parentRoute: typeof AuthenticatedCreatorMaterialsRouteRoute
    }
  }
}

interface AuthRouteChildren {
  AuthCompleteCreatorRoute: typeof AuthCompleteCreatorRoute
  AuthCompleteProfileRoute: typeof AuthCompleteProfileRoute
  AuthCreatorLoginRoute: typeof AuthCreatorLoginRoute
  AuthCreatorRegisterRoute: typeof AuthCreatorRegisterRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthMagicLinkRoute: typeof AuthMagicLinkRoute
  AuthOtpLoginRoute: typeof AuthOtpLoginRoute
  AuthVerifyLoginRoute: typeof AuthVerifyLoginRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCompleteCreatorRoute: AuthCompleteCreatorRoute,
  AuthCompleteProfileRoute: AuthCompleteProfileRoute,
  AuthCreatorLoginRoute: AuthCreatorLoginRoute,
  AuthCreatorRegisterRoute: AuthCreatorRegisterRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthMagicLinkRoute: AuthMagicLinkRoute,
  AuthOtpLoginRoute: AuthOtpLoginRoute,
  AuthVerifyLoginRoute: AuthVerifyLoginRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedCreatorMaterialsRouteRouteChildren {
  AuthenticatedCreatorMaterialsIdEditRoute: typeof AuthenticatedCreatorMaterialsIdEditRoute
  AuthenticatedCreatorMaterialsCreateMultimediaRoute: typeof AuthenticatedCreatorMaterialsCreateMultimediaRoute
  AuthenticatedCreatorMaterialsCreatePdfRoute: typeof AuthenticatedCreatorMaterialsCreatePdfRoute
}

const AuthenticatedCreatorMaterialsRouteRouteChildren: AuthenticatedCreatorMaterialsRouteRouteChildren =
  {
    AuthenticatedCreatorMaterialsIdEditRoute:
      AuthenticatedCreatorMaterialsIdEditRoute,
    AuthenticatedCreatorMaterialsCreateMultimediaRoute:
      AuthenticatedCreatorMaterialsCreateMultimediaRoute,
    AuthenticatedCreatorMaterialsCreatePdfRoute:
      AuthenticatedCreatorMaterialsCreatePdfRoute,
  }

const AuthenticatedCreatorMaterialsRouteRouteWithChildren =
  AuthenticatedCreatorMaterialsRouteRoute._addFileChildren(
    AuthenticatedCreatorMaterialsRouteRouteChildren,
  )

interface AuthenticatedCreatorRouteChildren {
  AuthenticatedCreatorMaterialsRouteRoute: typeof AuthenticatedCreatorMaterialsRouteRouteWithChildren
  AuthenticatedCreatorCreatorFaqRoute: typeof AuthenticatedCreatorCreatorFaqRoute
  AuthenticatedCreatorCreatorSupportRoute: typeof AuthenticatedCreatorCreatorSupportRoute
  AuthenticatedCreatorPaulRoute: typeof AuthenticatedCreatorPaulRoute
  AuthenticatedCreatorOutOfPrintPublicationIdRoute: typeof AuthenticatedCreatorOutOfPrintPublicationIdRoute
  AuthenticatedCreatorRequestsCreateRoute: typeof AuthenticatedCreatorRequestsCreateRoute
  AuthenticatedCreatorOutOfPrintIndexRoute: typeof AuthenticatedCreatorOutOfPrintIndexRoute
  AuthenticatedCreatorRequestsIndexRoute: typeof AuthenticatedCreatorRequestsIndexRoute
  AuthenticatedCreatorRequestsRequestIdEditRoute: typeof AuthenticatedCreatorRequestsRequestIdEditRoute
  AuthenticatedCreatorRequestsRequestIdIndexRoute: typeof AuthenticatedCreatorRequestsRequestIdIndexRoute
}

const AuthenticatedCreatorRouteChildren: AuthenticatedCreatorRouteChildren = {
  AuthenticatedCreatorMaterialsRouteRoute:
    AuthenticatedCreatorMaterialsRouteRouteWithChildren,
  AuthenticatedCreatorCreatorFaqRoute: AuthenticatedCreatorCreatorFaqRoute,
  AuthenticatedCreatorCreatorSupportRoute:
    AuthenticatedCreatorCreatorSupportRoute,
  AuthenticatedCreatorPaulRoute: AuthenticatedCreatorPaulRoute,
  AuthenticatedCreatorOutOfPrintPublicationIdRoute:
    AuthenticatedCreatorOutOfPrintPublicationIdRoute,
  AuthenticatedCreatorRequestsCreateRoute:
    AuthenticatedCreatorRequestsCreateRoute,
  AuthenticatedCreatorOutOfPrintIndexRoute:
    AuthenticatedCreatorOutOfPrintIndexRoute,
  AuthenticatedCreatorRequestsIndexRoute:
    AuthenticatedCreatorRequestsIndexRoute,
  AuthenticatedCreatorRequestsRequestIdEditRoute:
    AuthenticatedCreatorRequestsRequestIdEditRoute,
  AuthenticatedCreatorRequestsRequestIdIndexRoute:
    AuthenticatedCreatorRequestsRequestIdIndexRoute,
}

const AuthenticatedCreatorRouteWithChildren =
  AuthenticatedCreatorRoute._addFileChildren(AuthenticatedCreatorRouteChildren)

interface AuthenticatedLayoutAdvancedRouteChildren {
  AuthenticatedLayoutAdvancedContactRoute: typeof AuthenticatedLayoutAdvancedContactRoute
  AuthenticatedLayoutAdvancedDashboardRoute: typeof AuthenticatedLayoutAdvancedDashboardRoute
  AuthenticatedLayoutAdvancedExpiredCoursesRoute: typeof AuthenticatedLayoutAdvancedExpiredCoursesRoute
  AuthenticatedLayoutAdvancedSupportRoute: typeof AuthenticatedLayoutAdvancedSupportRoute
  AuthenticatedLayoutAdvancedCoursesCourseIdDetailsRoute: typeof AuthenticatedLayoutAdvancedCoursesCourseIdDetailsRoute
  AuthenticatedLayoutAdvancedCoursesCourseIdShortViewRoute: typeof AuthenticatedLayoutAdvancedCoursesCourseIdShortViewRoute
}

const AuthenticatedLayoutAdvancedRouteChildren: AuthenticatedLayoutAdvancedRouteChildren =
  {
    AuthenticatedLayoutAdvancedContactRoute:
      AuthenticatedLayoutAdvancedContactRoute,
    AuthenticatedLayoutAdvancedDashboardRoute:
      AuthenticatedLayoutAdvancedDashboardRoute,
    AuthenticatedLayoutAdvancedExpiredCoursesRoute:
      AuthenticatedLayoutAdvancedExpiredCoursesRoute,
    AuthenticatedLayoutAdvancedSupportRoute:
      AuthenticatedLayoutAdvancedSupportRoute,
    AuthenticatedLayoutAdvancedCoursesCourseIdDetailsRoute:
      AuthenticatedLayoutAdvancedCoursesCourseIdDetailsRoute,
    AuthenticatedLayoutAdvancedCoursesCourseIdShortViewRoute:
      AuthenticatedLayoutAdvancedCoursesCourseIdShortViewRoute,
  }

const AuthenticatedLayoutAdvancedRouteWithChildren =
  AuthenticatedLayoutAdvancedRoute._addFileChildren(
    AuthenticatedLayoutAdvancedRouteChildren,
  )

interface AuthenticatedLayoutBasicRouteChildren {
  AuthenticatedLayoutBasic2faRoute: typeof AuthenticatedLayoutBasic2faRoute
  AuthenticatedLayoutBasicProfileRoute: typeof AuthenticatedLayoutBasicProfileRoute
  AuthenticatedLayoutBasicPasskeyPasskeyRoute: typeof AuthenticatedLayoutBasicPasskeyPasskeyRoute
  AuthenticatedLayoutBasicPasskeyIndexRoute: typeof AuthenticatedLayoutBasicPasskeyIndexRoute
}

const AuthenticatedLayoutBasicRouteChildren: AuthenticatedLayoutBasicRouteChildren =
  {
    AuthenticatedLayoutBasic2faRoute: AuthenticatedLayoutBasic2faRoute,
    AuthenticatedLayoutBasicProfileRoute: AuthenticatedLayoutBasicProfileRoute,
    AuthenticatedLayoutBasicPasskeyPasskeyRoute:
      AuthenticatedLayoutBasicPasskeyPasskeyRoute,
    AuthenticatedLayoutBasicPasskeyIndexRoute:
      AuthenticatedLayoutBasicPasskeyIndexRoute,
  }

const AuthenticatedLayoutBasicRouteWithChildren =
  AuthenticatedLayoutBasicRoute._addFileChildren(
    AuthenticatedLayoutBasicRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedCreatorRoute: typeof AuthenticatedCreatorRouteWithChildren
  AuthenticatedLayoutAdvancedRoute: typeof AuthenticatedLayoutAdvancedRouteWithChildren
  AuthenticatedLayoutBasicRoute: typeof AuthenticatedLayoutBasicRouteWithChildren
  AuthenticatedCoursesCourseIdRoute: typeof AuthenticatedCoursesCourseIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCreatorRoute: AuthenticatedCreatorRouteWithChildren,
  AuthenticatedLayoutAdvancedRoute:
    AuthenticatedLayoutAdvancedRouteWithChildren,
  AuthenticatedLayoutBasicRoute: AuthenticatedLayoutBasicRouteWithChildren,
  AuthenticatedCoursesCourseIdRoute: AuthenticatedCoursesCourseIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  HowToUseRoute: HowToUseRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  ReaderEpubRoute: ReaderEpubRoute,
  ReaderPdfRoute: ReaderPdfRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
